module.exports = __webpack_public_path__ + "static/vision-thumb-2268503072b3dd05acd4fdadcf04ca20.jpg";